@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

.container {
	padding: Constants.$val-spacing-m;
	display: grid;
	gap: Constants.$val-spacing-s;
}

.block {
	display: flex;
	justify-content: space-between;
	align-items: center;

	border: 1px solid Colors.$col-greyConnection;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;

	background: Colors.$col-white;
}

.block-left {
	display: flex;
	align-items: center;
	gap: Constants.$val-spacing-m;
}

.block-index {
	display: inline-flex;
	align-items: center;
	justify-content: center;

	font-weight: 600;
	font-size: Constants.$val-fontSizeRegular;
	line-height: Constants.$val-lineHeightRegular;

	color: Colors.$col-design-gray8;
	background: Colors.$col-white;
}

.block-name {
	display: flex;
	align-items: center;
	gap: Constants.$val-spacing-s;

	font-weight: 500;
	font-size: Constants.$val-fontSizeRegular;
	line-height: Constants.$val-lineHeightRegular;
	color: Colors.$col-design-gray8;
}

.block-actions {
	display: flex;
	gap: Constants.$val-spacing-s;
}
